import { apiProps } from '-/Common/useApi'
import type { ExtractPropTypes, PropType } from 'vue'
import type { TablePaginationConfig } from 'ant-design-vue'
import type { ColumnType } from 'ant-design-vue/es/table'
import type { TableRowSelection } from 'ant-design-vue/es/table/interface'
import type { TableRequestApi, TableRequestParams } from './useTableRequest'

const { api, params, labelField, valueField, ...rest } = apiProps

export const tableSelectProps = {
  ...rest,
  value: {
    type: [String, Number, Array] as PropType<string | number | string[] | number[]>
  },
  mutiple: {
    type: Boolean,
    default: false
  },
  valueKey: {
    type: String,
    default: 'id'
  },
  /**
   * 请求接口函数
   */
  api: {
    type: Function as PropType<TableRequestApi>,
    required: true
  },
  params: {
    type: [Object, Function] as PropType<TableRequestParams>
  },
  useLastId: {
    type: Boolean,
    default: false
  },
  columns: {
    type: Array as PropType<ColumnType[]>,
    default: () => []
  },
  pagination: {
    type: [Boolean, Object] as PropType<false | TablePaginationConfig>,
    default: undefined
  },
  current: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  currentKey: {
    type: String as PropType<string>,
    default: 'name'
  },
  height: {
    type: [Number, String] as PropType<number | string>,
    default: 'calc(100vh - 300px)'
  },
  rowSelection: {
    type: Object as PropType<TableRowSelection>,
    default: () => {}
  }
}

export type TableSelectProps = ExtractPropTypes<typeof tableSelectProps>
